export default __webpack_public_path__ + "static/media/green-spinner.f608d408.svg";